import { createSlice } from '@reduxjs/toolkit';

export const advanced = createSlice({
  name: 'advanced',
  initialState: {
    advancedIsLoading: true,
    response: null,
    busyGreetingOptions: [],
    storageType: 'NEXTIVA_STORE',
    transferOnZero: false,
  },
  reducers: {
    clearBusyGreetingOptions: (state) => {
      state.busyGreetingOptions = [];
    },
    setAdvancedIsLoading: (state, action) => {
      state.advancedIsLoading = action.payload;
    },
    setAdvancedResponse: (state, action) => {
      state.response = action.payload;
    },
    setBusyGreetingOptions: (state, action) => {
      state.busyGreetingOptions = action.payload;
    },
    setStorageType: (state, action) => {
      state.storageType = action.payload;
    },
    setTransferOnZero: (state, action) => {
      state.transferOnZero = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setAdvancedIsLoading,
  setAdvancedResponse,
  setBusyGreetingOptions,
  setStorageType,
  setTransferOnZero,
  clearBusyGreetingOptions,
} = advanced.actions;

export default advanced.reducer;
